(
	function() {
		'use strict';

		angular.module('hhv.directives', [])
		.config(['$provide', function ($provide, $log) {
      $provide.decorator('inputDirective', ['$delegate', '$log', function($delegate, $log) {
        $log.debug('Hijacking input directive');
        var directive = $delegate[0];
        angular.extend(directive.link, {
          post: function(scope, element, attr, ctrls) {
            element.on('compositionupdate', function (event) {
              $log.debug('Composition update, faking end');
              element.triggerHandler('compositionend');
            });
          }
        });
        return $delegate;
      }]);
    }])
		///for composite language ket ups; dirty fixing 
		.directive('ignoreCompositionEvent', ['$timeout', function ($timeout) {
			return {
				priority: 0,
				restrict: 'A',
				link: function postLink(scope, element) {
					element.on('compositionend', function(event){
						var originalEvent = event.originalEvent;
						if(!originalEvent) 
							return;
						var charCode = originalEvent.data.charCodeAt(originalEvent.data.length-1);
						if(charCode == 44) charCode = 188;
						var keydownEvent = {
							type: 'keydown',
							keyCode: charCode
						};
						originalEvent.stopPropagation();
						originalEvent.preventDefault();
						element.one('input', function(inputEvent){
							//element.val(element.val().substring())
							var fixedString = element.val().replace(/,/g,'');
							element.val(fixedString);
							element.triggerHandler('input');
							element.triggerHandler(keydownEvent);
						})
					});
				}
			};
		}])
		//ngModel on contenteditable
		.directive("contenteditable", function() {
		  return {
			priority: 99,
			restrict: "A",
			require: "ngModel",
			link: function(scope, element, attrs, ngModel) {

			  function read() {
				ngModel.$setViewValue(element.html());
			  }

			  ngModel.$render = function() {
				element.html(ngModel.$viewValue || '');
			  };

			  element.bind('blur keyup change', function() {
				scope.$apply(read);
			  });
			}
		  };
		})
		.directive('autofocus', ['$timeout',
			function ($timeout) {
			  return {
				restrict: 'A',
				link: function ($scope, $element) {
				  $timeout(function () {
					$element[0].focus();
				  });
				}
			  };
			}
		])
		.directive('pwCheck', [function () {
			return {
				require: 'ngModel',
				link: function (scope, elem, attrs, ctrl) {
					scope.$watch(attrs.pwCheck, function (confirmPassword) {
						var isValid = ctrl.$viewValue === confirmPassword;
						ctrl.$setValidity('pwmatch', isValid);
					});
				}
			};
		}])
		///input[type=date] value from Date to formatted string
		.directive('formatDate',  ['$filter', function ($filter) {
			return {
				restrict: 'A',
				require: '?ngModel',
				link: function (scope, elem, attrs, ctrl) {
					if (!ctrl) return;


					ctrl.$formatters.push(function (a) {
						if(typeof a === 'undefined') return a;
						var filterOptions = attrs.formatDate.split(':');
						return $filter('date')(new Date(ctrl.$modelValue),filterOptions[0],filterOptions[1]);
					});

					ctrl.$parsers.push(function (viewValue) {
						if(typeof viewValue === 'undefined') return viewValue;
						var filterOptions = attrs.formatDate.split(':');
						var dateValue = new Date(viewValue);//.replace(/[^\d]/g, '');
						var formatted = $filter('date')(dateValue,filterOptions[0],filterOptions[1]);
						return formatted;
					});
				}
			};
		}])
		.directive('hvBrief', function(){
			return {
				priority: 1,
				restrict: 'A',
				replace: true,
				link: function($scope, elem, attrs) {
					$scope.extended = false;
					var getElemSize = function(){
						return elem[0].offsetHeight;//.height()};
					};
					///TODO	implement proper extend calculation
					var getRemainingSpace = function(){
						return {width: elem.width(), height: elem.height()};
					};
					$scope.$watch(getElemSize , function(newValue, oldValue, scope) {
						if(newValue > 100)
							$scope.extended = true;
						else  
							$scope.extended = false;
						$scope.$applyAsync();
					}, true);
				},
				templateUrl: function(elem, attrs) {
					var type = attrs.hvBrief || '';
					return '/template/article/Brief'+attrs.hvBrief[0].toUpperCase()+attrs.hvBrief.slice(1)+'Article.tpl.html';
				}
			};
		})
		.directive('queryTidy', ['$filter', function($filter){
			return {
				require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
				restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
				link: function($scope, iElm, iAttrs, ngModel) {
					ngModel.$formatters.push($filter('queryTidy'));
				}
			};
		}])
		.directive('clearWithEsc', function() {
			return {
				restrict: 'A',
				require: '?ngModel',
				link: function(scope, element, attrs, controller) {
					element.on('keydown', function(ev) {
						if (ev.keyCode != 27) return;

						scope.$apply(function() {
							controller.$setViewValue('');
							controller.$render();
						});
					});
				},
			};
		})
		.directive('hvDetail', function hvDetail(){
			return {
				priority: 1,
				restrict: 'A',
				replace: true,
				scope: {
					edit: '@',
					data: '='
				},
				link: function($scope, iElm, iAttrs, controller) {
					$scope.isEditing = function(){
						return !!($scope.data.isEditable() && $scope.edit === 'true');
					};
				},
				templateUrl: function(elem, attrs) {
					var type = attrs.hvDetail || '';
					return '/template/article/Detailed'+attrs.hvDetail[0].toUpperCase()+attrs.hvDetail.slice(1)+'Article.tpl.html';
				}
			};
		})
		.directive('hvTag', function(){
			return {
				priority: 1,
				restrict: 'A',
				replace: true,
				templateUrl: '/template/TagButton.tpl.html',

			};
		})
		.directive('hvSearch', ['db', function(db){
			return {
				priority: 1,
				restrict: 'A',
				scope: {
					options: '=hvsOptions'
				},
				controllerAs: 'vm',
				link: function($scope, elem, attrs) {

					$scope.$watch('options', function(newValue, oldValue, $scope) {
						if(!newValue) return false;
						$scope.options = db.getItems(newValue);
					}, false);

					$scope.$watch('options.isSearching', function(newValue, oldValue, $scope) {
						if(!$scope.options) return false;
						var isSearching = $scope.options.isSearching === undefined || $scope.options.isSearching;
						if(isSearching){
							elem.addClass('searching');
						}else{
							elem.removeClass('searching');
						}
					}, true);					
				}
			};
		}])
		/*global daum */
		.directive('daumPostcode', ['$document', '$timeout', function($document, $timeout){
			//Define Daum Script
			var isScriptLoaded = function() {
				return daum && daum.postcode && daum.Postcode;
			};

			var loadScript = function(then){
				if(isScriptLoaded()) return false;
				var headElement = (document.head || document.getElementsByTagName('head')[0]);
				var daumPostcodeScript = document.createElement('script');
				daumPostcodeScript.type = 'text\/javascript';
				daumPostcodeScript.onerror = function(error){
					console.error('Daum Script couldn\'t load', error);
				};
				daumPostcodeScript.onload = function(){
						var daumPostcode = daum.postcode.load(function(){
							if(then)
								then();
					});
				};
				headElement.appendChild(daumPostcodeScript);
				daumPostcodeScript.src = 'http://dmaps.daum.net/map_js_init/postcode.v2.js?autoload=false';
				return true;
			};

			return {
				// priority: 1,
				// terminal: true,
				scope: {
					query: '@',
					data: '=',
					oncomplete: '&'
				}, 
				// controller: function($scope, $element, $attrs, $transclude) {},
				// require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
				restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
				// template: '',
				// templateUrl: '',
				// replace: true,
				// transclude: true,
				// compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
				link: function($scope, iElm, iAttrs, controller) {
					var populate = function(data){
						var element = iElm[0];
						var completeHandler = $scope.oncomplete || function(){};
						new daum.Postcode({
							oncomplete: function(data){
								angular.extend($scope.data, data);
								$scope.oncomplete({data: data});
							},
							onresize : function(size) {
								element.style.height = size.height+'px';
							},
							width: '100%',
							height: '100%',
							animation: true,
						}).embed(element, {q: $scope.query});

						iElm.attr('tabindex', '-1');
						iElm.addClass('focus');

						//focus handler;
						var iframe = iElm.find('iframe');
						iframe.focus();
						var focusHandler = function(event){
							if(event.target ==  element) 
								return ;
							$timeout(function(){
								if (document.activeElement == iframe[0]) {
									iElm.triggerHandler('focus');
									$timeout(function(){
										iElm.focus();
									}, 0);
									iElm.addClass('focus');
								}else{
									iElm.triggerHandler({type: 'blur'});
									$timeout(function(){
										iElm.blur();
									}, 0);
									iElm.removeClass('focus');
								}
							},0);
						};

						angular.element(document).on('focusout', focusHandler);
						angular.element(document).on('focusin', focusHandler);
						$scope.$on('$destroy', function(){
							angular.element(document).off('focusin', focusHandler);
							angular.element(document).off('focusout', focusHandler);
						});
					};

					if(!isScriptLoaded()){
						loadScript(populate);
					}else{
						$timeout(populate, 0);
					}
				}
			};
		}])
		.directive('hvNews', ['$http', '$log', function($http, $log){
			var googleFeedApi = '//ajax.googleapis.com/ajax/services/feed/load?v=1.0&callback=JSON_CALLBACK?q=';
			var proxy = '/cors/?callback=JSON_CALLBACK&url=';

			var newsProviders = {
				googleNewsApi : {
					url: 'http://news.google.com/news?hl=ko&output=rss',
					params : {
						query: 'q'
					}
				},
				// naverNewsApi: {
				// 	url: 'http://openapi.naver.com/search?key=959cebf447033a1c5806fd3074f53d9f&target=news',
				// 	params: {
				// 		query: 'query',
				// 		start: 'start',
				// 		display: 'display'
				// 	}
				// }
			};

			return {
				priority: 1,
				scope: {
					query: '@',
					org: '=',
					start: '@',
					display: '@',
				}, // {} = isolate, true = child, false/undefined = no change
				restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
				templateUrl: '/template/NewsList.tpl.html',
				replace: true,
				link: function($scope, iElm, iAttrs, controller) {
					$scope.news = [];
					$scope.$watch('org', function(newValue, oldValue, $scope) {
						if(!newValue){
							return false;
						}
						$scope.news = newValue.news = [];
						$scope.isSearchingCounter = 0;
						var successHandler = function(response){
							$scope.attribution = response.data.content.rss.channel.copyright;
							var items = response.data.content.rss.channel.item;
							$scope.news.push.apply($scope.news, items);
							$scope.isSearchingCounter --;
						};
						var errorHandler = function(response){
							$log.error(key, response);
						};
						for(var key in newsProviders){
							$scope.isSearchingCounter ++;
							var provider = newsProviders[key];
							var url = provider.url;
							for(var param in provider.params){
								if($scope[param])
									url += '&'+provider.params[param]+'='+$scope[param];
							}
							var feedUrl = proxy + encodeURIComponent(url);
							$http.jsonp(feedUrl)
								.then(successHandler, errorHandler);
						}
					}, false);
				}
			};
		}]);
	}
)();